<div>
    <app-service-report-for-products-list></app-service-report-for-products-list>
</div>
<div>
    <app-service-report-for-products-form></app-service-report-for-products-form>
</div>